import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-primary-900 text-background-50 mt-16">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50 text-primary-900">
                <i className="ri-film-line text-lg" />
              </span>
              <span className="font-heading font-bold text-xl tracking-wide">韩国伦理</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-50/70 max-w-md">
              「韩国伦理」是一个聚焦韩国伦理电影与伦理题材电视剧的内容平台，聚合剧情介绍、影评与编辑专题推荐，帮助成年观众查找、浏览并发现值得细看的伦理影视作品。站内所有作品信息均为演示内容。
            </p>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-base mb-4">内容导航</h3>
            <ul className="flex flex-col gap-3 text-sm text-background-50/70">
              <li>
                <Link to="/" className="hover:text-accent-400 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/category/erotic" className="hover:text-accent-400 transition-colors">伦理电影</Link>
              </li>
              <li>
                <Link to="/category/drama" className="hover:text-accent-400 transition-colors">伦理电视剧</Link>
              </li>
              <li>
                <Link to="/search" className="hover:text-accent-400 transition-colors">搜索作品</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-base mb-4">关于平台</h3>
            <ul className="flex flex-col gap-3 text-sm text-background-50/70">
              <li>
                <Link to="/about" className="hover:text-accent-400 transition-colors">关于我们</Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-accent-400 transition-colors">版权声明</Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-accent-400 transition-colors">隐私政策摘要</Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-accent-400 transition-colors">联系方式与反馈</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-50/60">
          <p>© {year} 韩国伦理 · 韩国伦理影视内容专题平台</p>
          <p>本网站为内容展示演示站点，不提供播放、下载或支付服务。</p>
        </div>
      </div>
    </footer>
  );
}